/**
 * How it works Section JavaScript
 * Handles slider functionality
 */

// Prevent duplicate class declaration
if (typeof HowItWorks === 'undefined') {
  class HowItWorks {
    constructor() {
      this.sections = document.querySelectorAll('.wt-how-it-works');
      this.init();
    }

    init() {
      this.sections.forEach(section => {
        this.initSection(section);
      });
    }

    initSection(section) {
      // Prevent duplicate initialization
      if (section.dataset.howItWorksInitialized) return;
      
      const slider = section.querySelector('.wt-how-it-works__slider');
      
      if (!slider) return;

      // Initialize Swiper
      const swiperContainer = slider.querySelector('[data-swiper]');
      if (swiperContainer) {
        this.initSwiper(section, swiperContainer);
        section.dataset.howItWorksInitialized = 'true';
      }
    }

    initSwiper(section, container) {
      // The theme uses slideshow-section custom element which handles Swiper initialization
      // We just need to ensure the slideshow-section is properly initialized
      const slideshowSection = section.querySelector('slideshow-section');
      
      if (slideshowSection) {
        // Remove loading class
        container.classList.remove('loading');
        
        // The slideshow-section custom element will handle Swiper initialization
        // We can access the swiper instance through the custom element
        if (slideshowSection.swiper) {
          container.swiper = slideshowSection.swiper;
          
          // Update navigation and scrollbar elements
          this.updateSliderControls(section, slideshowSection);
          
          // Add section-specific event listeners
          this.addSectionEventListeners(section, slideshowSection.swiper);
        } else {
          // If swiper is not immediately available, wait for it
          this.waitForSwiper(section, slideshowSection);
        }
      } else {
        container.classList.remove('loading');
      }
    }

    waitForSwiper(section, slideshowSection) {
      // Poll for swiper instance to become available with timeout
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max wait time
      
      const checkSwiper = () => {
        if (slideshowSection.swiper) {
          const container = section.querySelector('[data-swiper]');
          if (container) {
            container.swiper = slideshowSection.swiper;
            this.updateSliderControls(section, slideshowSection);
            this.addSectionEventListeners(section, slideshowSection.swiper);
          }
        } else if (attempts < maxAttempts) {
          attempts++;
          // Check again in 100ms
          setTimeout(checkSwiper, 100);
        } else {
          console.warn('HowItWorks: Swiper instance not found after timeout');
        }
      };
      
      // Start checking
      checkSwiper();
    }

    updateSliderControls(section, slideshowSection) {
      if (slideshowSection && slideshowSection.swiper) {
        const swiper = slideshowSection.swiper;
        
        // Update navigation elements to point to header controls within this section
        if (swiper.params.navigation) {
          const nextBtn = section.querySelector('.wt-how-it-works__nav-next');
          const prevBtn = section.querySelector('.wt-how-it-works__nav-prev');
          
          if (nextBtn && prevBtn) {
            swiper.params.navigation.nextEl = nextBtn;
            swiper.params.navigation.prevEl = prevBtn;
            
            // Reinitialize navigation
            if (swiper.navigation) {
              swiper.navigation.init();
              swiper.navigation.update();
            }
          }
        }

        // Update scrollbar elements within this section
        if (swiper.params.scrollbar) {
          const scrollbarEl = section.querySelector('.wt-how-it-works__scrollbar');
          if (scrollbarEl) {
            swiper.params.scrollbar.el = scrollbarEl;
            
            // Reinitialize scrollbar
            if (swiper.scrollbar) {
              swiper.scrollbar.init();
              swiper.scrollbar.updateSize();
              swiper.scrollbar.setTranslate();
            }
          }
        }
      }
    }

    addSectionEventListeners(section, swiper) {
      if (swiper) {
        // Listen for slide changes on this specific swiper instance
        swiper.on('slideChange', () => {
          this.handleSlideChange(section, swiper);
        });
        
        // Listen for initialization completion
        swiper.on('init', () => {
          this.updateSliderControls(section, section.querySelector('slideshow-section'));
        });
      }
    }

    handleSlideChange(section, swiper) {
      // Custom logic for slide changes can be added here
      // For example, updating URL parameters, analytics tracking, etc.
      
      if (swiper) {
        section.dispatchEvent(new CustomEvent('how-it-works:slide-changed', {
          detail: {
            activeIndex: swiper.activeIndex,
            swiper: swiper
          }
        }));
      }
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new HowItWorks();
  });

  // Re-initialize on theme editor changes
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.wt-how-it-works')) {
        new HowItWorks();
      }
    });
  }

  // Export for potential external use
  window.HowItWorks = HowItWorks;
}